import React, {useEffect} from "react";
import Styles from "./AddColumns.module.scss";

const checkImg = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 5.25L7.07143 12.75L4.5 9.75" stroke="#02DEAB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

const minusImg = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7111 9.02755H6.34424" stroke="#FF0053" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7251 9.02773C1.7251 3.55115 3.55115 1.7251 9.02773 1.7251C14.5043 1.7251 16.3304 3.55115 16.3304 9.02773C16.3304 14.5043 14.5043 16.3304 9.02773 16.3304C3.55115 16.3304 1.7251 14.5043 1.7251 9.02773Z" stroke="#FF0053" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

const plusImg =  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.02755 6.34717V11.7085" stroke="#02DEAB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.7111 9.02755H6.34424" stroke="#02DEAB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7251 9.02773C1.7251 3.55115 3.55115 1.7251 9.02773 1.7251C14.5043 1.7251 16.3304 3.55115 16.3304 9.02773C16.3304 14.5043 14.5043 16.3304 9.02773 16.3304C3.55115 16.3304 1.7251 14.5043 1.7251 9.02773Z" stroke="#02DEAB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


const AddRemoveInput = ({type,name,addOrRemoveCol,columns,added}) => {
  return(
      <div style={{opacity : (!added.includes(name) && type === 'remove')  ? '0.3' : '1'}}  onClick={() => addOrRemoveCol(columns.id,columns.source, name ,columns.type ,type)} className={`d-flex justify-content-between align-items-center ${Styles.row}`}>
          {type === 'remove' && checkImg}
          <p className="dark-gary-2" title={name}>{name.toString().substr(0,10)}</p>
          {type === 'remove' ? minusImg : plusImg}
      </div>
  )
}
export default AddRemoveInput;
